<template>
  <skeleton theme="opacity" shape="radius" bg-color="#dcdbdc" class="p-3">
    <div class="row">
      <div class="col-12" style="padding-left: 10px;margin-top: 5px">
        <tb-skeleton :aspect-ratio="0.15"></tb-skeleton>
      </div>
      <div class="col-12" style="padding-left: 10px;margin-top: 10px">
        <tb-skeleton :aspect-ratio="0.15"></tb-skeleton>
      </div>
      <div class="col-12" style="padding-left: 10px;margin-top: 10px">
        <tb-skeleton :aspect-ratio="0.15"></tb-skeleton>
      </div>
      <div class="col-12" style="padding-left: 10px;margin-top: 10px">
        <tb-skeleton :aspect-ratio="0.15"></tb-skeleton>
      </div>
      <div class="col-12" style="padding-left: 10px;margin-top: 10px">
        <tb-skeleton :aspect-ratio="0.15"></tb-skeleton>
      </div>
      <div class="col-12" style="padding-left: 10px;margin-top: 10px">
        <tb-skeleton :aspect-ratio="0.15"></tb-skeleton>
      </div>
    </div>
  </skeleton>
</template>

<script>
  export default {
    name: 'sk-navbar-sidebar',
  };
</script>
